export const style = {
  slotsContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: 'max-content',
    alignItems: 'center',
    backgroundColor: '#F6F6F6',
    padding: '70px 0px'
  },
  listOfSlots: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 'max-content',
    width: '100%',
    alignItems: 'center',
    backgroundColor: '#F6F6F6',
    padding: '0 9px',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px'
  }
}